import React from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './about.css'

const About = (props) => {
  return (
    <div className="about-container1">
      <Helmet>
        <title>About - ClearPath Digital</title>
        <meta property="og:title" content="About - ClearPath Digital" />
        <link
          rel="canonical"
          href="https://clearpathdigital.teleporthq.app/about"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="about-hero-section">
        <div className="hero-video-wrapper">
          <video
            src="https://videos.pexels.com/video-files/6964012/6964012-hd_1920_1080_25fps.mp4"
            loop="true"
            muted="true"
            poster="https://images.pexels.com/videos/6964012/pictures/preview-0.jpg"
            autoPlay="true"
            playsInline="true"
            className="hero-background-video"
          ></video>
          <div className="hero-overlay"></div>
        </div>
        <div className="about-hero-content-container">
          <div className="about-hero-text-block">
            <h1 className="about-hero-title hero-title">
              High-Converting Websites for Serious Businesses
            </h1>
            <p className="about-hero-subtitle hero-subtitle">
              We build professional sales assets that turn visitors into booked
              calls. No fluff, no generic templates—just high-performance
              engineering for growth-focused companies in France, Luxembourg,
              and the EU.
            </p>
            <div className="about-hero-cta-group">
              <Link to="/contact-book-a-call">
                <div className="about-thq-btn-elm1 btn btn-primary btn-xl">
                  <span>Book a free website strategy call</span>
                </div>
              </Link>
              <span className="about-hero-reassurance">
                Limited availability for Q3 projects
              </span>
            </div>
          </div>
        </div>
      </section>
      <section className="about-problem-section">
        <div className="problem-container">
          <h2 className="section-title">Why Most Business Websites Fail</h2>
          <div className="problem-carousel">
            <div className="problem-item">
              <div className="about-problem-card">
                <div className="problem-icon-wrapper">
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </svg>
                </div>
                <h3 className="section-subtitle">The Clarity Gap</h3>
                <p className="section-content">
                  Most sites confuse visitors with vague buzzwords. We focus on
                  crystal-clear positioning that communicates your value in
                  under 5 seconds.
                </p>
                <ul className="problem-list">
                  <li className="section-content">
                    <span>Intent-based messaging</span>
                  </li>
                  <li className="section-content">
                    <span>Frictionless user journeys</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="problem-item">
              <div className="about-problem-card">
                <div className="problem-icon-wrapper">
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"></path>
                  </svg>
                </div>
                <h3 className="section-subtitle">The Speed Trap</h3>
                <p className="section-content">
                  A 1-second delay in load time can drop conversions by 7%. Our
                  websites are engineered for lightning-fast performance across
                  all devices.
                </p>
                <ul className="problem-list">
                  <li className="section-content">
                    <span>Clean, optimized code</span>
                  </li>
                  <li className="section-content">
                    <span>Global CDN delivery</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="problem-item">
              <div className="about-problem-card">
                <div className="problem-icon-wrapper">
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M16 7h6v6"></path>
                    <path d="m22 7l-8.5 8.5l-5-5L2 17"></path>
                  </svg>
                </div>
                <h3 className="section-subtitle">Zero Conversion Flow</h3>
                <p className="section-content">
                  A &quot;pretty site&quot; is a cost; a conversion-focused site
                  is an asset. We design every pixel with a single goal: booking
                  your next client.
                </p>
                <ul className="problem-list">
                  <li className="section-content">
                    <span>Strategic CTA placement</span>
                  </li>
                  <li className="section-content">
                    <span>Trust-building social proof</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="about-process-section">
        <div className="process-container">
          <h2 className="section-title">From Strategy to Launch</h2>
          <div className="process-steps-wrapper">
            <div className="about-process-step">
              <div className="about-step-number">
                <span>01</span>
              </div>
              <div className="step-content">
                <h3 className="about-step-title">Strategy Call</h3>
                <p className="section-content">
                  We define your goals, audience, and core offer to build a
                  conversion map.
                </p>
                <span className="step-time">Week 1</span>
              </div>
            </div>
            <div className="about-process-step">
              <div className="about-step-number">
                <span>02</span>
              </div>
              <div className="step-content">
                <h3 className="about-step-title">Architecture</h3>
                <p className="section-content">
                  Wireframing and high-impact copywriting to ensure the message
                  hits home.
                </p>
                <span className="step-time">Week 2-3</span>
              </div>
            </div>
            <div className="about-process-step">
              <div className="about-step-number">
                <span>03</span>
              </div>
              <div className="step-content">
                <h3 className="about-step-title">Engineering</h3>
                <p className="section-content">
                  Custom design and development focused on speed and mobile
                  perfection.
                </p>
                <span className="step-time">Week 4-6</span>
              </div>
            </div>
            <div className="about-process-step">
              <div className="about-step-number">
                <span>04</span>
              </div>
              <div className="step-content">
                <h3 className="about-step-title">Launch &amp; Grow</h3>
                <p className="section-content">
                  Final testing, SEO optimization, and handover of your new
                  sales asset.
                </p>
                <span className="step-time">Week 7-8</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="team-section">
        <div className="team-container">
          <h2 className="section-title">The Expertise Behind Your Growth</h2>
          <div className="team-grid">
            <div className="team-member">
              <div className="member-image-wrapper">
                <img
                  alt="Agency Lead"
                  src="https://images.pexels.com/photos/7108188/pexels-photo-7108188.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  className="member-image"
                />
              </div>
              <h3 className="section-subtitle">Strategy &amp; Copy</h3>
              <p className="section-content">
                Focused on business logic and conversion psychology to turn
                readers into leads.
              </p>
            </div>
            <div className="team-member">
              <div className="member-image-wrapper">
                <img
                  alt="Design Lead"
                  src="https://images.pexels.com/photos/4491459/pexels-photo-4491459.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  className="member-image"
                />
              </div>
              <h3 className="section-subtitle">UX &amp; UI Design</h3>
              <p className="section-content">
                Creating premium, high-trust interfaces that reflect your
                brand&apos;s authority.
              </p>
            </div>
            <div className="team-member">
              <div className="member-image-wrapper">
                <img
                  alt="Development Lead"
                  src="https://images.pexels.com/photos/313691/pexels-photo-313691.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  className="member-image"
                />
              </div>
              <h3 className="section-subtitle">Performance Dev</h3>
              <p className="section-content">
                Engineering clean, scalable code for maximum speed and SEO
                visibility.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="cta-section">
        <div className="cta-container">
          <div className="cta-card-wrapper">
            <h2 className="section-title">
              Ready to Turn Your Website Into a Sales Asset?
            </h2>
            <p className="section-content">
              Book your free 30-minute strategy call today. We&apos;ll audit
              your current site and outline a roadmap for conversion-focused
              growth.
            </p>
            <div className="cta-action-block">
              <Link to="/contact-book-a-call">
                <div className="about-thq-btn-elm2 btn-accent btn btn-xl">
                  <span>Book my free strategy call</span>
                </div>
              </Link>
              <div className="cta-microcopy">
                <p className="section-content">
                  Next steps: You&apos;ll receive a calendar link to pick a
                  time. No obligation, just value.
                </p>
                <span className="gdpr-note">
                  <span>
                    By submitting, you agree to our
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <a href="/privacy">
                    <div>
                      <span>Privacy Policy</span>
                    </div>
                  </a>
                  <span>. We respect EU GDPR data standards.</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="about-container3">
        <div className="about-container4">
          <Script
            html={`<style>
        @keyframes scrollRail {0% {transform: translateX(0);}
100% {transform: translateX(-50%);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="about-container5">
        <div className="about-container6">
          <Script
            html={`<script defer data-name="about-page-interactions">
(function(){
  // Handle smooth scroll for anchor links
  const anchorLinks = document.querySelectorAll('a[href^="#"]');
  anchorLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      const targetId = link.getAttribute('href');
      if (targetId === '#') return;
      
      const targetElement = document.querySelector(targetId);
      if (targetElement) {
        e.preventDefault();
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  // Simple scroll reveal for timeline items
  const timelineItems = document.querySelectorAll('.timeline-item');
  const revealOnScroll = () => {
    const triggerBottom = window.innerHeight * 0.85;
    
    timelineItems.forEach(item => {
      const itemTop = item.getBoundingClientRect().top;
      if (itemTop < triggerBottom) {
        item.style.opacity = '1';
        item.style.transform = 'translateX(0)';
      }
    });
  };

  // Set initial state for timeline items
  timelineItems.forEach(item => {
    item.style.opacity = '0';
    item.style.transform = 'translateX(-20px)';
    item.style.transition = 'all 0.6s ease-out';
  });

  window.addEventListener('scroll', revealOnScroll);
  revealOnScroll(); // Run once on load

  // Duplicate testimonials for infinite effect
  const rail = document.querySelector('.testimonials-rail');
  if (rail) {
    const cards = rail.innerHTML;
    rail.innerHTML = cards + cards; // Clone the set of cards
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default About
